import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { firestore } from '@/lib/firebase';
import { addMinutes } from 'date-fns';

export async function createNotification({ disabled, snooze }: any) {
  const snoozeUntil = snooze
    ? Timestamp.fromDate(addMinutes(new Date(), 10))
    : null;

  await setDoc(doc(firestore, 'configs/notifications'), {
    disabled,
    snoozeUntil,
  });
  return {
    disabled,
    snoozeUntil: snoozeUntil?.toDate(),
  };
}

export async function getNotifications() {
  const snapshot = await getDoc(doc(firestore, 'configs', 'notifications'));
  const data = snapshot.data();
  if (data?.snoozeUntil) {
    data.snoozeUntil = data.snoozeUntil.toDate();
  }
  return data;
}
